import { assert } from '@ember/debug';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class GoalsDeleteModalIndexComponent extends Component {
  @service intl;

  @tracked delete_confirmation_text = '';

  @action
  dismissModal() {
    if (!this.args.closeModal)
      assert('Pass a callback function to the "closeModal" param');
    this.delete_confirmation_text = '';
    this.args?.closeModal?.();
  }

  get confirmTextIsValid() {
    return (
      this.delete_confirmation_text ===
      this.intl.t('dictionary.delete').toLowerCase()
    );
  }

  @action
  confirmDelete(e) {
    e?.preventDefault?.();
    if (!this.args.confirmDelete)
      assert('Pass a callback function to the "confirmDelete" param');
    if (this.confirmTextIsValid) {
      this.args?.confirmDelete?.();
      this.delete_confirmation_text = '';
    }
  }

  @action
  focusInput(element) {
    element?.focus();
  }

  @action
  setConfirmationText(event) {
    this.delete_confirmation_text = event.target.value;
  }
}
